var map = {
	"./bug.svg": 49,
	"./dark.svg": 50,
	"./dragon.svg": 51,
	"./electric.svg": 52,
	"./fairy.svg": 53,
	"./fighting.svg": 54,
	"./fire.svg": 55,
	"./flying.svg": 56,
	"./ghost.svg": 57,
	"./grass.svg": 58,
	"./ground.svg": 59,
	"./ice.svg": 60,
	"./normal.svg": 61,
	"./poison.svg": 62,
	"./psychic.svg": 63,
	"./rock.svg": 64,
	"./steel.svg": 65,
	"./water.svg": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;